'use client';

import React, { forwardRef } from 'react';
import { type BasicShopUIPropTypes } from 'shop-ui/types';
import STYLE from './Divider.module.scss';

interface DividerProps extends BasicShopUIPropTypes {
    // 自行加入其他 props
    content: string;
}

export const Divider = forwardRef<HTMLDivElement, DividerProps>((props, ref) => {
    const { style } = props;

    return (
        <div className={STYLE.divider} ref={ref} style={style}>
            <div className={STYLE.dividerLine} />
        </div>
    );
});

Divider.displayName = 'Divider';
